import axios from "axios";
import {GET_ALL_CART, LOADING} from "../actionTypes";
import {customerToken} from "helper";
import {adminToken} from "../../helper";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

const {SET_TRUE, SET_FALSE} = LOADING;

export const get = ({countryCode, mobile}) => {
    return async dispatch => {
        if (!countryCode || !mobile) return;
        dispatch({type: SET_TRUE});

        try {
            // const token = await adminToken();

            const token = await customerToken({mobile, countryCode});

            const {data} = await axios.get(`${AWS_SERVER_APIS}/allcartdata`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            dispatch({type: GET_ALL_CART, payload: data?.data});
        } catch (err) {
            console.log(err);
        } finally {
            dispatch({type: SET_FALSE});
        }
    };
};
